module.exports = __webpack_public_path__ + "img/heart-fill.c2406227.svg";